var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component"},[_c('vjsf',{attrs:{"view-mode":"","disabled":"","omit-missing-fields":_vm.omitMissingFields,"schema":_vm.schema,"ui-schema":_vm.uiSchema,"form-data":_vm.formData,"custom-formats":_vm.customFormats,"widgets":_vm.widgets}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }